var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('dt',{staticClass:"c-info-window-list__title"},[_vm._v(_vm._s(_vm.item.label))]),_c('dd',{staticClass:"c-info-window-list__content"},[_vm._v(_vm._s(_vm.item.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }